/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_OfflineInputs */

const en_planner_offline = /** @type {(inputs: Planner_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishly needs a connection for a suggestion.`)
};

const de_planner_offline = /** @type {(inputs: Planner_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für einen Vorschlag braucht Dishly eine Verbindung.`)
};

/**
* | output |
* | --- |
* | "Dishly needs a connection for a suggestion." |
*
* @param {Planner_OfflineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_offline = /** @type {((inputs?: Planner_OfflineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_OfflineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_offline(inputs)
	return en_planner_offline(inputs)
});